import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  dashboardContainer: {
    padding: '44px max(calc(100% - 1108px) / 2, 48px) 32px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
  },
});

export default useStyles;
